<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active">
                <i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <div class="row col-lg-12">
          <div class="form-group col-sm-2">
            <EditForm
              :default-values="{}"
              create
              title="Create table"
              @finish="handleItemsUpdate"
            >
              <template #button="{ onclick }">
                <b-button type="button" variant="success" @click="onclick"
                  ><i class="fas fa-plus"></i> Create</b-button
                >
              </template>
            </EditForm>
          </div>
        </div>

        <TablesFilters
          ref="tablesFilters"
          :items="items"
          @filtered="onTablesFiltered"
        />

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="scroll-wrapper">
                <div class="scroll"></div>
              </div>
              <div class="table-wrapper mb-10">
                <b-table
                  :key="tableListKey"
                  primary-key="tableId"
                  :striped="true"
                  :small="true"
                  :hover="true"
                  :empty-text="emptyText"
                  show-empty
                  :busy="!!cancel"
                  :items="filteredItems"
                  :fields="fields"
                  :no-local-sorting="true"
                  :sort-icon-left="true"
                  @sort-changed="sortingChanged"
                >
                  <template #cell(zeroSide)="row">
                    {{
                      row.item.options && row.item.options.isLeft !== undefined
                        ? row.item.options.isLeft === true
                          ? 'Left'
                          : 'Right'
                        : ''
                    }}
                  </template>

                  <template #cell(logo)="row">
                    <div
                      style="max-width: 150px"
                      class="mb-2"
                      v-if="
                        row.item &&
                          row.item.options &&
                          row.item.options.pictureDesktop &&
                          row.item.options.pictureDesktop.length > 0
                      "
                    >
                      <b-img
                        :src="
                          row.item &&
                          row.item.options &&
                          row.item.options.pictureDesktop
                            ? makeLogoPath(row.item.options.pictureDesktop) +
                              '?t=' +
                              Date.now()
                            : ''
                        "
                        fluid
                        alt="Picture desktop"
                      ></b-img>
                    </div>
                    <div
                      style="max-width: 150px"
                      class="mb-2"
                      v-if="
                        row.item &&
                          row.item.options &&
                          row.item.options.pictureMobile &&
                          row.item.options.pictureMobile.length > 0
                      "
                    >
                      <b-img
                        :src="
                          row.item &&
                          row.item.options &&
                          row.item.options.pictureMobile
                            ? makeLogoPath(row.item.options.pictureMobile) +
                              '?t=' +
                              Date.now()
                            : ''
                        "
                        fluid
                        alt="Picture mobile"
                      ></b-img>
                    </div>
                  </template>

                  <template #cell(croupierName)="row">
                    {{ croupierNames[row.item.tableId] }}
                  </template>

                  <template #cell(toggleTable)="row">
                    <ToggleTable
                      :table="{ ...row.item }"
                      :isTableClosed="isTableClosed"
                      v-on:finish="handleTableUpdate"
                      v-if="isRefresh"
                    />
                  </template>

                  <template #cell(tableType)="row">
                    <div v-if="row.item.options">
                      {{ row.item.options.isVip ? 'VIP' : 'STANDARD' }}
                    </div>
                  </template>

                  <template #cell(gameType)="row">
                    {{ $store.getters['gameTypes/getName'](row.item.gameType) }}
                  </template>

                  <template #cell(isVirtualTable)="row">
                    {{ row.item.isVirtualTable === true ? 'Yes' : 'No' }}
                  </template>

                  <template #cell(parentTableId)="row">
                    {{ row.item.originalTable != null ? row.item.originalTable : '—' }}
                  </template>

                  <template #cell(actions)="row">
                    <EditForm
                      :key="'table-edit-' + row.item.tableId"
                      :default-values="{ ...row.item }"
                      title="Edit table"
                      @finish="handleItemsUpdate"
                    />
                    <RemoveForm
                      :object="row.item.tableId"
                      message="Please confirm removing table"
                      :url="'/api/v1/tables/' + row.item.tableId"
                      @finish="handleItemsUpdate"
                    />
                    <LogoutCroupier
                      :object="row.item.tableId"
                      :default-values="{ ...row.item }"
                      message="Please confirm logout croupier on table"
                      :url="
                        '/api/v1/tables/logout-croupier/' + row.item.tableId
                      "
                      title="Logout croupier"
                      :disabled="!croupierNames[row.item.tableId]"
                      @finish="handleItemsUpdate"
                    />
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import EditTableForm from '../../components/Tables/EditTableForm'
import LogoutCroupier from '../../components/Tables/LogoutCroupier'
import RemoveForm from '../../components/remove-form/RemoveForm.vue'
import axios from 'axios'
import { getRouteIcon, ROUTE_TABLES } from '../../utils/routerIcons'
import ToggleTable from '../../components/Tables/ToggleTable'
import TablesFilters from '../../components/Tables/TablesFilters'
import Vue from 'vue'

function getDefaultPagination() {
  return {
    onPage: 25,
    page: 1,
    records: 0,
    count: 5,
    pageSizeOption: [25, 50, 100, 200]
  }
}

function getDefaultSorts() {
  return {
    by: 'tableId',
    desc: 1
  }
}

export default {
  components: {
    EditForm: EditTableForm,
    LogoutCroupier,
    RemoveForm,
    ToggleTable,
    TablesFilters
  },
  data() {
    return {
      pollingTableStatuses: null,
      pollingCroupierNames: null,
      cancel: null,
      error: null,
      sorts: getDefaultSorts(),
      items: [],
      filteredItems: [],
      filters: {},
      pagination: getDefaultPagination(),
      isRefresh: true,
      tableListKey: 0
    }
  },
  computed: {
    isTableClosed() {
      return this.$store.getters['tableStatuses/tableStatuses']
    },
    croupierNames() {
      return this.$store.getters['tableStatuses/croupierNames']
    },
    fields() {
      let columns = [
        { key: 'tableId', label: 'Table ID', sortable: true },
        { key: 'name', label: 'Table name', sortable: true },
        { key: 'gameType', label: 'Game type' },
        { key: 'isVirtualTable', label: 'Virtual' },
        { key: 'parentTableId', label: 'Original table' },
        { key: 'zeroSide', label: 'Zero side' },
        { key: 'tableType', label: 'Table type' },
        { key: 'croupierName', label: 'Croupier Name' },
        { key: 'toggleTable', label: 'Closed' },
        { key: 'logo', label: 'Logo' },
        { key: 'actions', label: 'Actions' }
      ]

      let debugKeys = ['logo']

      if (!this.$store.getters['isShowDebugTools']) {
        columns = columns.filter(({ key }) => !debugKeys.includes(key))
      }

      return columns
    },
    backUrl() {
      return process.env.VUE_APP_BACK_URL
    },
    cdnBackUrl() {
      return process.env.VUE_APP_CDN_BACK_URL
    },
    emptyText() {
      if (this.cancel) {
        return 'Loading items..'
      }

      if (this.error) {
        return this.error
      }

      return 'There are no records to show'
    },
    routeIcon: () => getRouteIcon(ROUTE_TABLES)
  },
  methods: {
    onTablesFiltered(value) {
      this.filteredItems = value
    },
    syncFilteredItems() {
      const filters = this.$refs.tablesFilters
      this.filteredItems = filters ? filters.filteredItems.slice() : this.items.slice()
      this.tableListKey += 1
    },
    makeLogoPath(path) {
      if (path[0] === '/') {
        return this.cdnBackUrl + path
      }

      return this.cdnBackUrl + '/' + path
    },
    sortingChanged(ctx) {
      this.sorts.by = ctx.sortBy
      this.sorts.desc = ctx.sortDesc
      this.pagination.page = 1

      this.loadItems()
    },
    handleItemsUpdate() {
      this.loadItems()
    },
    handleTableUpdate(table) {
      for (let index in this.items) {
        if (this.items[index].id === table.id) {
          Vue.set(this.items, index, table)
          break
        }
      }
    },
    loadItems() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector('#loading-container'),
        name: 'wave'
      })

      this.items = []

      let self = this
      loadingInstance.show()

      this.$http({
        url: '/api/v1/tables',
        params: {
          // pagination
          limit: this.pagination.onPage,
          offset: this.pagination.onPage * (this.pagination.page - 1),

          // sort params
          orderBy: this.sorts.by,
          direction: this.sorts.desc ? 'DESC' : 'ASC'
        },
        method: 'GET',
        cancelToken: new axios.CancelToken(c => {
          self.cancel = c
        })
      })
        .then(resp => {
          let { items } = resp.data
          this.items = items
          this.$nextTick(() => {
            this.syncFilteredItems()
          })
        })
        .catch(err => {
          this.items = []
          this.error = err
        })
        .finally(() => {
          loadingInstance.close()
          this.cancel = null
        })
    },
    refreshToggle() {
      if (this.pollingTableStatuses) {
        clearInterval(this.pollingTableStatuses)
      }

      this.pollingTableStatuses = setInterval(() => {
        this.updateToggle()
      }, 10000)

      if (this.pollingCroupierNames) {
        clearInterval(this.pollingCroupierNames)
      }

      this.pollingCroupierNames = setInterval(() => {
        this.updateCroupierNames()
      }, 15000)
    },
    async updateToggle() {
      await this.$store.dispatch('tableStatuses/updateTableStatuses')
      this.isRefresh = false
      await Vue.nextTick()
      this.isRefresh = true
    },
    async updateCroupierNames() {
      await this.$store.dispatch('tableStatuses/updateCroupierNames')
      this.isRefresh = false
      await Vue.nextTick()
      this.isRefresh = true
    },
    cancelRequest() {
      if (this.cancel) {
        this.cancel('this -> cancel previous request')
      }
    },
    onPageChange(page) {
      this.pagination.page = page
      this.loadItems()
    },
    onPageSizeChange(pageSize) {
      this.pagination.page = 1
      this.pagination.onPage = pageSize
      this.loadItems()
    },
    onFinishEdit() {
      this.loadItems()
    }
  },
  async beforeMount() {
    await this.$store.dispatch('gameTypes/loadList')
  },
  mounted() {
    this.loadItems()
    this.updateToggle()
    this.updateCroupierNames()
    this.refreshToggle()
    this.$store.dispatch('sourcesModule/loadList')
  },
  destroyed() {
    if (this.pollingTableStatuses) {
      clearInterval(this.pollingTableStatuses)
      this.pollingTableStatuses = null
    }
    if (this.pollingCroupierNames) {
      clearInterval(this.pollingCroupierNames)
      this.pollingCroupierNames = null
    }
  }
}
</script>
